var map = {
	"./bdbi.svg": 81,
	"./bdbi.svg:Zone.Identifier": 82,
	"./claro-club.svg:Zone.Identifier": 83,
	"./contact-bg (2).svg:Zone.Identifier": 84,
	"./contact-bg.svg": 85,
	"./digitalTransformation.svg": 86,
	"./digitalTransformation.svg:Zone.Identifier": 87,
	"./gridia-accent.svg:Zone.Identifier": 88,
	"./gridia.svg:Zone.Identifier": 89,
	"./portfolio-1/claro-club.svg": 40,
	"./portfolio-1/gridia-accent.svg": 41,
	"./portfolio-1/gridia.svg": 42,
	"./portfolio-1/symfonia.svg": 43,
	"./shape1.svg": 90,
	"./shape1.svg:Zone.Identifier": 91,
	"./shape2.svg": 92,
	"./shape2.svg:Zone.Identifier": 93,
	"./shape3.svg": 94,
	"./shape3.svg:Zone.Identifier": 95,
	"./symfonia.svg:Zone.Identifier": 96,
	"./talentIcon.svg": 97,
	"./talentIcon.svg:Zone.Identifier": 98
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39;